import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../state/store";
import { ReactiveFormInput } from "../../form/ReactiveFormInput";
import { Agency } from "../../../models/Agency";
import { SubmitHandler, useForm } from "react-hook-form";
import { updateAgencyTwilioConfig } from "../../../state/agencies/action";
import { useEffect, useState } from "react";
import { Toast } from "../../Toast";
import { TwilioConfigNumber } from "../../../models/User";
import Button from "../../Button";
import { CheckIcon } from "@heroicons/react/24/outline";
import { toast, ToastContainer } from "react-toastify";
import { LoadingMask } from "../../LoadingMask";
import { setCurrentUserAgencyTwilioConfig } from "../../../state/users/actions";

export const AgencyTwilioConfigModule = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const currentAgency = useSelector((state: any) => state.users.currentUser?.agency);
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const error = useSelector((state: any) => state.agencies.error);

    useEffect(() => {
        if (showError) {
            Toast(t(error?.reason ?? "SOMETHING_WENT_WRONG"), t(error?.cause_info));
            setShowError(false);
        }
    }, [showError, error, t]);

    const methods = useForm<TwilioConfigNumber>({});
    const { handleSubmit, control, reset } = methods;

    useEffect(() => {
        console.log(currentAgency.main_twilio_config_number)
        reset(currentAgency.main_twilio_config_number)
    }, [currentAgency])
    
    const onSubmit: SubmitHandler<any> = async (data: any) => {
        setIsLoading(true);
        const twilioConfig = {
            label: data.label,
            twilio_auth_token: data.twilio_auth_token,
            twilio_account_sid: data.twilio_account_sid,
            twilio_twiml_app_sid: data.twilio_twiml_app_sid,
            messaging_service_sid: data.messaging_service_sid,
            twilio_api_key: data.twilio_api_key,
            twilio_api_secret: data.twilio_api_secret,
        };

        if (currentAgency.main_twilio_config_number_id) {
            dispatch(updateAgencyTwilioConfig({twilioConfigId: currentAgency.main_twilio_config_number_id, data: twilioConfig})
            ).then((e) => {
                if (e.type === "agencies/updateTwilioConfig/rejected") {
                    setShowError(true);
                    setIsLoading(false);
                } else {
                    //let config = (e.payload || {}) as TwilioConfigNumber;
                    //dispatch(setCurrentUserAgencyTwilioConfig(config));
                    toast(t("SAVED_SUCCESFULLY"));
                    setIsLoading(false);
                }
            });
        }
    };

    return(
        <>
            {isLoading && <LoadingMask />}
            <ToastContainer progressStyle={{ background: "#D4AF37" }} />
            <div className="text-black max-h-full p-5 md:w-full">
                <div className="text-md font-bold text-black pl-3 mt-2">
                    {t("TWILIO_CONFIG")}
                </div>
                <div className="pb-5 pt-5 w-full flex flex-wrap">
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/3"
                        label={t("LABEL")}
                        name={`label`}
                    />
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/3"
                        label={t("ACCOUNT_SID")}
                        name={`twilio_account_sid`}
                    />
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/3"
                        label={t("AUTH_TOKEN")}
                        name={`twilio_auth_token`}
                    />
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/3"
                        label={t("TWIML_APP_SID")}
                        name={`twilio_twiml_app_sid`}
                    />
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/3"
                        label={t("API_KEY")}
                        name={`twilio_api_key`}
                    />
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/3"
                        label={t("API_SECRET")}
                        name={`twilio_api_secret`}
                    />
                    <ReactiveFormInput
                        control={control}
                        className="md:w-1/3"
                        label={t("MESSAGING_SERVICE_SID")}
                        name={`messaging_service_sid`}
                    />
                </div>
                
                <div className="pb-5 text-right">
                    <Button onClick={handleSubmit(onSubmit)}>
                        <span className="flex items-center font-semibold pr-3">
                            <div className="w-8 p-1 aspect-square mr-2">
                                <CheckIcon />
                            </div>
                            {t("SAVE")}
                        </span>
                    </Button>
                </div>
            </div>
        </>
    )
}